import React, { useState, useRef, useContext } from "react";
import Swal from "sweetalert2";
import { Modal, Navbar, Container, Button } from "react-bootstrap";
import JsonFormatter from "react-json-formatter";

import AuthService from "../../../services/Admin/AuthService";
import LeadManagementService from "../../../services/Admin/LeadManagementService";
import HttpError from "../../../utill/HttpError";
import LoadingContext from "../../../store/loading-context";
import { useHistory } from "react-router-dom";

const TxnDetailsDialog = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const data = props.selectedRow;
  const commercials = data.commercials ? JSON.parse(data.commercials) : {};

  const jsonStyle = {
    propertyStyle: { color: "red" },
    stringStyle: { color: "green" },
    numberStyle: { color: "darkorange" },
  };

  const [status, setStatus] = useState();

  const remarkRef = useRef();

  const updateHandler = async (id) => {
    const remark = remarkRef.current.value;

    if (!status) {
      Swal.fire("Opps!", "Invalid Status", "error");
      return;
    }

    props.handleClose();
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await LeadManagementService.updateLeadStatus(
        token,
        id,
        status,
        remark
      );
      const status1 = responseData.status;
      const message = responseData.message;

      if (status1 === "SUCCESS") {
        //  await props.fetch();
        Swal.fire("Success!", message, "success");
      } else {
        props.handleOpen();
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      props.handleOpen();
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
    // setIsLoading(false);
  };

  return (
    <Modal
      show={props.isModalOpen}
      onHide={props.handleClose}
      size="xl"
      fullscreen
      scrollable
    >
      {/* Header */}
      <Navbar bg="primary" variant="dark">
        <Container fluid>
          <Navbar.Brand>TXN Details</Navbar.Brand>
          <Button variant="outline-light" onClick={props.handleClose}>
            ✕
          </Button>
        </Container>
      </Navbar>

      {/* Body */}
      <Modal.Body>
        {" "}
        {data && (
          <div className="row">
            <div className="col-md-6">
              <ul class="list-group list-group-unbordered mb-3">
                {/* <li class="list-group-item">
                            <b>User ID</b>{" "}
                            <span class="float-right">
                              {data
                                ? data.tbl_user.user_id +
                                  " (" +
                                  data.tbl_user.name +
                                  ")"
                                : ""}
                            </span>
                          </li>
                          <li class="list-group-item">
                            <b>Policy No</b>{" "}
                            <span
                              class="float-right"
                              //   style={{ fontSize: "18px", fontWeight: "bold" }}
                            >
                              {data ? data.policy_no : ""}
                            </span>
                          </li>
      
                          <li class="list-group-item">
                            <b>Registration No</b>{" "}
                            <span class="float-right">
                              {data ? data.registration_no : ""}
                            </span>
                          </li>
      
                          <li class="list-group-item">
                            <b>Partner Code</b>{" "}
                            <span class="float-right">
                              {data ? data.partner_code : ""}
                            </span>
                          </li>
      
                          <li class="list-group-item">
                            <b>Status</b>{" "}
                            <span class="float-right">{data ? data.status : ""}</span>
                          </li>
      
                          {data.commission_amount && (
                            <li class="list-group-item">
                              <b>Commission Amount</b>{" "}
                              <span class="float-right">
                                {data ? data.commission_amount : ""}
                              </span>
                            </li>
                          )}
      
                          {data.modified_on && (
                            <li class="list-group-item">
                              <b>Last Updated On</b>{" "}
                              <span class="float-right">
                                {data ? data.modified_on : "-"}
                              </span>
                            </li>
                          )}
      
                          {data.remark && (
                            <li class="list-group-item">
                              <b>Remark</b>{" "}
                              <span class="float-right">
                                {data ? data.remark : "-"}
                              </span>
                            </li>
                          )} */}
              </ul>

              {data && data.status === "PENDING" && (
                <div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Status</label>
                    <div class="col-sm-9">
                      <select
                        name="title"
                        class="form-control"
                        onChange={(e) => {
                          setStatus(e.target.value);
                        }}
                      >
                        <option value="">---Select Status---</option>
                        <option value="SUCCESS">SUCCESS</option>
                        <option value="REJECTED">REJECTED</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Commission Amount
                    </label>
                    <div class="col-sm-9">
                      <input
                        disabled
                        className="form-control"
                        placeholder="Commission Amount"
                        defaultValue={commercials ? commercials.amount : ""}
                      />
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Remark</label>
                    <div class="col-sm-9">
                      <textarea
                        ref={remarkRef}
                        className="form-control"
                        placeholder="Remark"
                        rows="3"
                        defaultValue={data ? data.remark : ""}
                      ></textarea>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-6">
              {data && (
                <JsonFormatter json={data} tabWith="4" jsonStyle={jsonStyle} />
              )}
            </div>
          </div>
        )}
      </Modal.Body>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default"
          onClick={props.handleClose}
        >
          Close
        </button>

        {data && data.status === "PENDING" && (
          <button
            type="button"
            class="btn btn-primary"
            onClick={() => {
              updateHandler(data ? data.id : "");
            }}
          >
            Submit
          </button>
        )}
      </div>
    </Modal>
  );
};

export default TxnDetailsDialog;
